import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-title">StoryBox Solutions</h3>
            <p className="footer-desc">
              Leading IT solutions provider specializing in software development, mobile apps, testing, and data warehouse management.
            </p>
            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/team" className="footer-link">Our Team</Link></li>
              <li><Link to="/vision" className="footer-link">Vision & Mission</Link></li>
              <li><Link to="/career" className="footer-link">Careers</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services/software-development" className="footer-link">Software Development</Link></li>
              <li><Link to="/services/android-development" className="footer-link">Android Development</Link></li>
              <li><Link to="/services/software-testing" className="footer-link">Software Testing</Link></li>
              <li><Link to="/services/data-warehouse" className="footer-link">Data Warehouse</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <MapPin size={18} />
                <span>16/959, 1st Floor, City Tower, Wandoor, Malappuram DT, Kerala , India</span>
              </li>
              <li className="footer-contact-item">
                <Phone size={18} />
                <span>+91 88 4847 6045</span>
              </li>
              <li className="footer-contact-item">
                <Mail size={18} />
                <span>info@storyboxsolutions.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} StoryBox Solutions Pvt. Ltd. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/privacy" className="footer-bottom-link">Privacy Policy</Link>
            <span className="footer-divider">|</span>
            <Link to="/terms" className="footer-bottom-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
